import axios from "../../axiosInstance";

let abortController = null; // Global variable to track the AbortController

export const quoteService = (stepcheck, setstepcheck, payload) => {
  // Abort previous requests if any
  if (abortController) {
    abortController.abort(); // Cancel any ongoing requests
  }

  // Create a new AbortController for the current request
  abortController = new AbortController();
  const signal = abortController.signal;

  const carriers = [
    ...(stepcheck["Package"] === true
      ? [
          "canpar",
          "gls",
          "ups",
          "canadaPost",
          "fedex",
          "ics",
          "dhl",
          "customRates",
        ]
      : []),
    ...(stepcheck["Pallet"] === true
      ? ["dayAndRoss", "kindersley", "xpo", "vitran", "mo"]
      : []),
  ];

  let completedRequests = 0;

  // Clear previous QuoteData before making new requests
  setstepcheck((prevStepCheck) => ({
    ...prevStepCheck,
    QuoteData: [], // Reset QuoteData for the new request
    Pending: true, // Ensure the loader starts for the new request
  }));

  carriers.forEach((carrier) => {
    const request = {
      method: "POST",
      url: `get-all-rates/${carrier}`,
      data: payload,
      signal, // Attach the abort signal to the request
    };

    axios(request)
      .then((result) => {
        try {
          const response = result.data;
          if (response.result) {
            // Update QuoteData with each response
            setstepcheck((prevStepCheck) => {
              const updatedData = [
                ...prevStepCheck.QuoteData,
                ...response.result,
              ].sort((a, b) => a.total - b.total);
              return {
                ...prevStepCheck,
                QuoteData: updatedData,
              };
            });
          }
        } catch (error) {
          console.error(error);
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          console.log(`Request for carrier ${carrier} was canceled`);
        } else {
          console.error(`Error with carrier ${carrier}:`, error);
        }
      })
      .finally(() => {
        // Increment completed requests only if the request was not aborted
        if (!signal.aborted) {
          completedRequests += 1;
        }

        // Set Pending to false only when all active requests have completed
        if (completedRequests === carriers.length) {
          setstepcheck((prevStepCheck) => ({
            ...prevStepCheck,
            Pending: false,
          }));
        }
      });
  });
};

export const specficQuoteService = async (id, payload) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`get-specific-rates/${id}`, payload);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const createShipmentService = async (id, payload) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`create-specific-shipment/${id}`, payload);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};
